module.exports = __webpack_public_path__ + "media/images/manifest/microbius-144-b5eeba0ff6e466d101768a65cf312587.png";